import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ufla-email-template-dialog',
    templateUrl: './email-template-dialog.component.html',
    styleUrls: [
        './email-template-dialog.component.scss',
    ],
    standalone: false,
})
export class EmailTemplateDialogComponent {
    data = inject<{
    bccAddresses: string;
    confirmColor: 'primary' | 'warn' | 'accent';
}>(MAT_DIALOG_DATA);


    copyToClipBoard(inputTargetEmailSubject: HTMLTextAreaElement) {
        navigator.clipboard.writeText(inputTargetEmailSubject.value).then(text => console.log(text));
    }
}
